import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';

export const canShareWithTeam = (): boolean =>
	currentUserHasAccess(PermissionName.SHARE_WITH_TEAM);
